import { BehaviorSubject, Observable } from 'rxjs';

import { SearchParams } from '@interfaces/modules/tours/search';
import { SearchResultResponse, ToursSearchResult } from '@interfaces/tours-search-result';
import { ToursSearchSort } from '@interfaces/services/api/tours-search.endpoint';

export interface SearchData {
  id: string;
  params: SearchParams;
  page: number;
  sort?: ToursSearchSort;
}

export interface SearchCreateParams {
  data: SearchData;
  resultSource: BehaviorSubject<ToursSearchResult>;
}

export class Search {
  private readonly id: string;
  private readonly params: SearchParams;
  private readonly page: number;
  private readonly sort?: ToursSearchSort;
  private readonly result$$: BehaviorSubject<ToursSearchResult>;

  static from(resultState: ToursSearchResult) {
    const { id, page, params } = resultState;
    const { sort } = resultState;
    const resultSource = new BehaviorSubject(resultState);

    return new Search({ resultSource, data: { id, page, params, sort } });
  }

  constructor({ data, resultSource }: SearchCreateParams) {
    this.id = data.id;
    this.params = data.params;
    this.page = data.page;
    this.sort = data.sort;
    this.result$$ = resultSource;
  }

  getSearchId() {
    return this.id;
  }

  getPageNumber() {
    return this.page;
  }

  getParams() {
    return this.params;
  }

  getSort() {
    return this.sort;
  }

  asObservable(): Observable<ToursSearchResult> {
    return this.result$$.asObservable();
  }

  next(response: SearchResultResponse) {
    this.result$$.next({ id: this.id, params: this.params, page: this.page, sort: this.sort, res: response });
  }

  finish(response: SearchResultResponse) {
    this.result$$.next({ id: this.id, params: this.params, page: this.page, sort: this.sort, res: response });
    this.result$$.complete();
  }

  error(err: Error) {
    this.result$$.error(err);
  }

  destroy() {
    this.result$$.complete();
  }
}
